"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExpiredTokenErrorHandler = void 0;
var expired_token_error_handling_strategy_1 = require("./expired-token-error-handling-strategy");
var handleExpiration = function () {
    return expired_token_error_handling_strategy_1.expiredTokenErrorHandlingContext.handleTokenRefresh();
};
exports.defaultExpiredTokenErrorHandler = {
    handleExpiration: handleExpiration,
};
